<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
	<div
		class="layout"
		:slots="slots"
		data-test="Layout-component"
		v-bind="{
			variant: variant || null,
			fluid: fluid || null
		}"
	>
		<div
			v-if="Number(slots) === 1"
			data-test="Layout-SingleSlot"
			class="slot"
		>
			<slot />
		</div>
		<template v-else>
			<div
				v-for="(col, index) in Number(slots)"
				:key="index"
				:slot="(index + 1).toString()"
				:data-test="`Layout-slot-${(index + 1).toString()}`"
				class="slot"
			>
				<slot :name="(index + 1)" />
			</div>
		</template>
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "Layout",
	props: {
		slots: { type: [String, Number], default: 1 },
		variant: { type: String, default: null },
		fluid: { type: Boolean, default: false }
	},
	setup() {
		return {};
	}
});
</script>
